import { useDevelopmentDetails } from 'listing-details/hooks/useDevelopmentDetails/useDevelopmentDetails';
import React from 'react';

import { withOptimizely, WithOptimizelyProps } from 'shared/optimizely';

import { DevelopmentDetailsProps } from './DevelopmentDetails.types';
import Summary from './Summary/Summary';

const DevelopmentDetails: React.FC<
    DevelopmentDetailsProps & WithOptimizelyProps
> = ({ data: branchData, optimizely }) => {
    const isDevelopmentDetailsEnabled = useDevelopmentDetails(optimizely);

    if (!isDevelopmentDetailsEnabled) return null;

    const branchIsDeveloper = branchData?.memberType === 'developer';

    // TODO: make "developmentIdString" available by listingId on GQL LDP
    const [, developmentIdString] =
        branchData?.branchDetailsUri?.match(/-([0-9]*)\/$/) || [];
    if (!branchIsDeveloper || !developmentIdString) return null;

    const developmentId = parseInt(developmentIdString);
    if (isNaN(developmentId)) return null;

    return (
        <Summary
            developmentId={developmentId}
            ddpLink={branchData?.branchDetailsUri || null}
        />
    );
};

export default withOptimizely(DevelopmentDetails);
